import React from "react";
import { coreValuesData } from "./data";
import "../assests/CSS/AboutComponent4.css";

const AboutComponent4 = () => {
  return (
    <section className="about4-section">
      <h2 className="about4-title">Our Core Values</h2>
      <div className="about4-grid">
        {coreValuesData.map((item) => (
          <div
            key={item.id}
            className={`about4-card ${
              item.type === "text" ? "about4-text-card" : "about4-img-card"
            }`}
          >
            {item.type === "image" && (
              <img src={item.image} alt={item.title || "Core Value"} />
            )}
            {item.type === "text" && (
              <div className="about4-text-content">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default AboutComponent4;
